import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerMemberManagementDashboardType } from "../../looker-member-management-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-member-address",
  templateUrl: "./member-address.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberAddressComponent {
filters: string[] = ["Projects"];
dashboardType = LookerMemberManagementDashboardType.MemberAddress;
hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, HideFilters.CUSTOMER_NAME2, "Organization_ID", "Customer_Name"];
}

